import type { IAdminDashboardRepository } from "@/application/ports/repositories";
import type { AdminDashboardStats } from "@/domain/admin";
import { apiClient } from "../client";

export class AdminDashboardRepository implements IAdminDashboardRepository {
	async getStats(): Promise<AdminDashboardStats> {
		const response =
			await apiClient.get<AdminDashboardStats>("/admin/dashboard");
		return response.data;
	}
}
